/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type consultAnExpert_viewer = {
    readonly isConsultAnExpertDisabled: boolean | null;
    readonly " $refType": "consultAnExpert_viewer";
};
export type consultAnExpert_viewer$data = consultAnExpert_viewer;
export type consultAnExpert_viewer$key = {
    readonly " $data"?: consultAnExpert_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"consultAnExpert_viewer">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "consultAnExpert_viewer"
};
(node as any).hash = '77bdaf5c917ef984e301547fd2f2d5a9';
export default node;
